export const GENDERS = [
  "Agender",
  "Androgyne",
  "Androgynous",
  "Bigender",
  "Cis female",
  "Cis male",
  "Cis man",
  "Cis woman",
  "Cis",
  "Cisgender female",
  "Cisgender male",
  "Cisgender man",
  "Cisgender woman",
  "Cisgender",
  "Demi-boy",
  "Demi-girl",
  "Demi-man",
  "Demi-woman",
  "Demiflux",
  "Demigender",
  "F2M",
  "FTM",
  "Female to male trans man",
  "Female to male transgender man",
  "Female to male transsexual man",
  "Female to male",
  "Gender fluid",
  "Gender neutral",
  "Gender nonconforming",
  "Gender questioning",
  "Gender variant",
  "Genderflux",
  "Genderqueer",
  "Hermaphrodite",
  "Intersex man",
  "Intersex person",
  "Intersex woman",
  "Intersex",
  "M2F",
  "MTF",
  "Male to female trans woman",
  "Male to female transgender woman",
  "Male to female transsexual woman",
  "Male to female",
  "Man",
  "Multigender",
  "Neither",
  "Neutrois",
  "Non-binary",
  "Omnigender",
  "Other",
  "Pangender",
  "Polygender",
  "T* man",
  "T* woman",
  "Trans female",
  "Trans male",
  "Trans man",
  "Trans person",
  "Trans woman",
  "Trans",
  "Transexual female",
  "Transexual male",
  "Transexual man",
  "Transexual person",
  "Transexual woman",
  "Transexual",
  "Transgender female",
  "Transgender person",
  "Transmasculine",
  "Trigender",
  "Two* person",
  "Two-spirit person",
  "Two-spirit",
  "Woman",
  "Xenogender",
];
